import {Component, Input} from "@angular/core";
import {FileDetails, Order} from "../../../store/state/order.state";
import {ChangeSet} from "../history/order-history.model";
import {EndpointsProvider} from "../../../umbrella-common/endpoints/endpoint-provider.service";

@Component({
    selector: 'transfer-documents-info',
    templateUrl: './transfer-documents-info.template.html',
    styleUrls: ['./transfer-documents-info.style.scss'],
    standalone: false
})
export class TransferDocumentsInfoComponent {

	@Input() blockInputs: boolean = false;
	@Input() order: Order;
	@Input() changeSet: ChangeSet;
	@Input() detailsVisible: boolean = false;

	constructor(private endpoints: EndpointsProvider) {
	}

	get certificateDocuments(): FileDetails[] {
		return this.order.certificateFiles;
	}

	get reportDocuments(): FileDetails[] {
		return this.order.reportFiles;
	}

	onCertificateDownload(file: FileDetails) {
		this.endpoints.documents.downloadCertificate(this.order.orderCorrelationId, file.fileUuid);
	}

	onReportDownload(file: FileDetails) {
		this.endpoints.documents.downloadReport(this.order.orderCorrelationId, file.fileUuid);
	}

	certificateDocumentsWereChanged(): boolean {
		return !!this.changeSet && this.changeSet.changes.certificateFilesChanged;
	}

	reportDocumentsWereChanged(): boolean {
		return !!this.changeSet && this.changeSet.changes.reportFilesChanged;
	}

}
